"use client";

import { getImageURL, sanitizeHTML } from "@/lib";

export const HomePageAbout = ({ data = {}, slug = "text_icons" }) => {
    const { text, list = [] } = data;

    return (
        <>
            <section className="about__section about__ind_section" id={slug}>
                <div className="custom-container">
                    <div className="row">
                        <div className="col-12">
                            <div className="about__area">
                                <div className="about__content">
                                    <div className="row">
                                        <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                                            <div className="about__header text-center fs-48 text-uppercase">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizeHTML(text),
                                  }}
                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-12 col-xl-12 offset-xl-1">
                            <ul className="counter__list list-unstyled">
                                {Array.isArray(list) &&
                                    list.map((item, idx) => (
                                        <li className="counter__item" key={idx}>
                                            <div className="img__wrap">
                                                {item?.icons?.src && (
                                                    <img
                                                        className="img-fluid"
                                                        src={getImageURL(
                                                            item.icons.src
                                                        )}
                                                        alt={
                                                            item.icons.alt || ""
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="content__area">
                                <div
                                  className="heading fs-86 fw-300"
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizeHTML(item?.number),
                                  }}
                                />

                                                <div className="content__wrap fs-20 fw-500">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: sanitizeHTML(item?.description),
                                    }}
                                  />
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
